// components/pages/AboutPage.tsx
import React from 'react';
import {
  Container,
  Typography,
  Box,
  Card,
  CardContent,
  Avatar,
} from '@mui/material';
import {
  Store as StoreIcon,
  LocalShipping as ShippingIcon,
  Security as SecurityIcon,
  Support as SupportIcon,
} from '@mui/icons-material';

const AboutPage: React.FC = () => {
  const features = [
    {
      icon: <StoreIcon />,
      title: 'Productos Frescos',
      description: 'Seleccionamos los mejores productos para tu hogar.'
    },
    {
      icon: <ShippingIcon />,
      title: 'Entrega Rápida',
      description: 'Llevamos tus compras hasta la puerta de tu casa.'
    },
    {
      icon: <SecurityIcon />,
      title: 'Pagos Seguros',
      description: 'Transacciones protegidas y métodos de pago confiables.'
    },
    {
      icon: <SupportIcon />,
      title: 'Atención 24/7',
      description: 'Estamos aquí para ayudarte cuando nos necesites.'
    },
  ];

  return (
    <Container maxWidth="lg" sx={{ py: 4 }}>
      <Box textAlign="center" mb={6}>
        <Typography variant="h3" component="h1" gutterBottom>
          Acerca de El Piñón
        </Typography>
        <Typography variant="h6" color="text.secondary" paragraph>
          Tu minimarket de confianza, ahora también online
        </Typography>
      </Box>

      <Box 
        sx={{ 
          display: 'flex', 
          flexDirection: { xs: 'column', md: 'row' },
          gap: 4,
          mb: 6,
          alignItems: 'center'
        }}
      >
        <Box sx={{ flex: 1 }}>
          <Typography variant="h4" gutterBottom>
            Nuestra Historia
          </Typography>
          <Typography variant="body1" paragraph>
            El Piñón nació como un pequeño negocio familiar con la visión de brindar 
            productos de calidad a nuestra comunidad. Durante años hemos sido el 
            minimarket de confianza del barrio.
          </Typography>
          <Typography variant="body1" paragraph>
            Hoy damos el siguiente paso llevando nuestro servicio al mundo digital, 
            manteniendo la misma calidad y calidez humana que nos caracteriza, pero 
            con la comodidad de poder hacer tus compras desde casa.
          </Typography>
        </Box>
        <Box sx={{ flex: 1 }}>
          <Box
            component="img"
            src="https://elpinon2.wpcomstaging.com/wp-content/uploads/2025/11/WhatsApp-Image-2025-11-03-at-16.33.01_e87d08f2.jpg"
            alt="El Piñón Minimarket"
            sx={{
              width: '100%',
              height: '300px',
              objectFit: 'cover',
              borderRadius: 2,
            }}
          />
        </Box>
      </Box>

      <Box textAlign="center" mb={4}>
        <Typography variant="h4" gutterBottom>
          ¿Por qué elegir El Piñón?
        </Typography>
      </Box>

      <Box 
        sx={{ 
          display: 'grid',
          gridTemplateColumns: { xs: '1fr', sm: 'repeat(2, 1fr)', md: 'repeat(4, 1fr)' },
          gap: 3,
          mb: 6
        }}
      >
        {features.map((feature, index) => (
          <Card key={index} sx={{ height: '100%', textAlign: 'center', p: 2 }}>
            <CardContent>
              <Avatar
                sx={{
                  bgcolor: 'primary.main',
                  width: 60,
                  height: 60,
                  mx: 'auto',
                  mb: 2,
                }}
              >
                {feature.icon}
              </Avatar>
              <Typography variant="h6" gutterBottom>
                {feature.title}
              </Typography>
              <Typography variant="body2" color="text.secondary">
                {feature.description}
              </Typography>
            </CardContent>
          </Card>
        ))}
      </Box>

      <Box textAlign="center" sx={{ py: 4, bgcolor: 'grey.50', borderRadius: 2 }}>
        <Typography variant="h5" gutterBottom>
          Únete a la familia El Piñón
        </Typography>
        <Typography variant="body1" color="text.secondary">
          Regístrate y disfruta de ofertas exclusivas y un servicio personalizado.
        </Typography>
      </Box>
    </Container>
  );
};

export default AboutPage;